import React from 'react';
import Select, { components } from "react-select";
const LIMIT = 10;
const LimitedMenuList = (props) => {
  const childrenArray = React.Children.toArray(props.children);
  return (
    <components.MenuList {...props}>
      {childrenArray.slice(0, LIMIT)}
    </components.MenuList>
  );
};
const FilterBar = ({
  activeFilter,
  setActiveFilter,
  category,
  setCategory,
  subcategory,
  setSubcategory,
  search,
  setSearch,
  categories,
  subcategories
}) => {
  const filterChips = [
    { id: 0, label: 'All' },
    { id: 1, label: 'Courses' },
    { id: 2, label: 'Videos' },
    { id: 3, label: 'Audios' },
    { id: 4, label: 'Podcasts' },
  ];
  const categoryOptions = [
  { value: "", label: "All Categories" },
  ...categories.map((cat) => ({
    value: cat.id,
    label: cat.name,
  })),
];
const subCategoryOptions=[
  { value: "", label: "All Subcategories" },
  ...subcategories.map((cat) => ({
    value: cat.id,
    label: cat.name,
  })),
];
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    padding: "6px",
    borderRadius: "10px",     // rounded-xl
    borderColor: state.isFocused ? "#0f6abf" : "#D1D5DB", // border-gray-300
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(15, 106, 191, 0.2)" // focus:ring-[#0f6abf]/20
      : "none",
    outline: "none",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#0f6abf" : "#D1D5DB",
    },
    minHeight: "auto",
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "#9CA3AF", // text-gray-400
  }),

  singleValue: (provided) => ({
    ...provided,
    color: "#111827", // text-gray-900
  }),
};


  return (
<div className="w-full flex flex-col gap-4">
  {/* FILTER BAR */}
  <div className="w-full flex flex-wrap md:flex-nowrap gap-4 md:gap-3 bg-white rounded-2xl p-5 md:p-6 border border-gray-200 shadow-sm mb-4 items-center relative z-10">
    
    {/* SEARCH */}
     <div className="relative flex-1 w-full">
    <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>

    <input
      type="text"
      placeholder="Search videos, categories, or keywords..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

    {/* FILTER CONTROLS */}
    <div className="flex flex-wrap md:flex-nowrap gap-3 md:gap-3 items-center w-full md:w-auto">
      <Select
        options={categoryOptions}
        isSearchable
        classNamePrefix="filter"
        components={{ MenuList: LimitedMenuList }}
        value={categoryOptions.find((opt) => opt.value === category) || null}
        onChange={(selected) => setCategory(selected?.value || "")}
        placeholder="Search category..."
        className="w-full md:w-64"
        styles={customStyles}
      />

      <Select
        options={subCategoryOptions}
        isSearchable
        classNamePrefix="filter"
        components={{ MenuList: LimitedMenuList }}
        value={subCategoryOptions.find((opt) => opt.value === subcategory) || null}
        onChange={(selected) => setSubcategory(selected?.value || "")}
        placeholder="Search subcategory..."
        className="w-full md:w-64"
        styles={customStyles}
      />

      <button className="flex items-center gap-2 px-5 py-3 rounded-xl border border-gray-300 bg-gray-50 text-gray-700 font-medium hover:bg-[#e8f0f7] hover:border-[#0f6abf] hover:text-[#0f6abf] transition-colors">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
        </svg>
        Filters
      </button>
    </div>
  </div>

  {/* FILTER CHIPS */}
  <div className="overflow-x-auto bg-white rounded-2xl p-4 border border-gray-200 shadow-sm mb-8">
    <div className="flex gap-2 flex-nowrap">
      {filterChips.map((chip) => (
        <button
          key={chip.id}
          onClick={() => {
            setCategory('');
            setSubcategory('');
            setSearch('');
            setActiveFilter(chip.id);
          }}
          className={`flex-shrink-0 whitespace-nowrap px-4 py-2 rounded-xl border text-sm font-medium transition-all ${
            activeFilter === chip.id
              ? "bg-[#0f6abf] border-[#0f6abf] text-white"
              : "bg-white border-gray-300 text-gray-700 hover:border-gray-400 hover:bg-gray-50"
          }`}
        >
          {chip.label}
        </button>
      ))}
    </div>
  </div>
</div>

  );
};

export default FilterBar;
